import axios from "axios";

// Konfiguriere die Basis-URL
const BASE_URL = import.meta.env.VITE_JOBSOURCE_BASE_URL;

const login = async (email, password) => {
  try {
    console.debug("Versuche, mit E-Mail zu authentifizieren:", email);

    if (!BASE_URL) {
      console.error("[loginService] BASE_URL fehlt!");
      throw new Error("Missing API configuration");
    }

    // Sende die Login-Anfrage an das Backend
    const fullUrl = `${BASE_URL}/api/auth/login`;
    console.debug("[loginService] Sending POST to:", fullUrl);
    
    const response = await axios.post(
      fullUrl,
      { email, password },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.debug("Login erfolgreich, Token:", response.data.token ? "vorhanden" : "fehlt");

    return response; 

  } catch (error) {
    console.error("Fehler beim Login:", error.response?.status, error.response?.data);
    throw error;
  }
};

export default { login };